<script lang="ts">
	export let url: string;
</script>

<link rel="icon" type="image/x-icon" href={url} />
